import React, { useState, useEffect, useRef } from "react";
import QRCode from "react-qr-code";
import EventLabel from "../../components/EventLabel";
import { getUrlParam } from "../../helpers/url.helper";

const QR = ({ settings, setAspectRatio }) => {
  const { useBadgeNo, content } = settings;
  const [badgeNumber, setbadgeNumber] = useState("No badge number");
  const wrapRef = useRef();
  let padding = 0;
  useEffect(() => {
    let badgeNum = getUrlParam("badgeno");
    if (!badgeNum) {
      badgeNum = getUrlParam("clientkey");
    }
    setbadgeNumber(badgeNum);
    setAspectRatio(1);
    setTimeout(() => setAspectRatio(1), 1000);
    setTimeout(() => setAspectRatio(1), 2000);
    setTimeout(() => setAspectRatio(1), 3000);
    setTimeout(() => setAspectRatio(1), 5000);
    setTimeout(() => setAspectRatio(1), 7000);
  }, []);
  if (wrapRef.current) {
    var elStyle = window.getComputedStyle(wrapRef.current);
    padding = parseFloat(elStyle.paddingTop.replace("px", "")) + parseFloat(elStyle.paddingBottom.replace("px", ""));
  }
  if (useBadgeNo && !badgeNumber) {
    return (
      <div ref={wrapRef} >
        <EventLabel name="QRMissingBadgeNo" groupName={"Content.StaticLabels"} />
      </div>
    );
  }
  else if(!useBadgeNo && !content){
    return (
      <div ref={wrapRef} >
        <EventLabel name="QRMissingContent" groupName={"Content.StaticLabels"} />
      </div>
    );
  }

  return (
    <div ref={wrapRef} className={"qr-wrap"}>
      <QRCode size={(wrapRef.current?.clientHeight || 150) - padding} value={useBadgeNo ? badgeNumber : content} />
    </div>
  );
};

export default QR;
